//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import BaseLoadingComponent from '@/components/common/BaseLoadingComponent';
export default {
  name: 'RolesComponent',
  components: {
    BaseLoadingComponent: BaseLoadingComponent
  },
  data: function data() {
    return {
      rolesInca: {},
      isLoading: false,
      locale: ''
    };
  },
  created: function created() {
    this.getRolesDescription(this.$i18n.locale);
  },
  methods: {
    getRolesDescription: function getRolesDescription(lang) {
      var _this = this;
      this.isLoading = true;
      userSettingsService.getRolesDescription(lang).then(function (response) {
        _this.rolesInca = response.data;
        console.log(_this.rolesInca);
      }).finally(function () {
        _this.isLoading = false;
      });
    },
    getRoleTitle: function getRoleTitle(role) {
      if (this.rolesInca[role]) {
        return "".concat(role);
      }
      return role;
    },
    getRoleName: function getRoleName(role) {
      if (this.rolesInca[role]) {
        return "".concat(this.rolesInca[role].name);
      }
      return "---";
    }
  },
  watch: {
    '$i18n.locale': function $i18nLocale(newLocale, oldLocale) {
      this.getRolesDescription(newLocale);
    }
  }
};